import { CloseOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Drawer, Row, Popover } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
  formatNumberWithDots,
  calculateTimeDifference,
} from "../../helpers/utils";
import TicketDetailsDrawer from "../Common/DetailTicket";
import moment from "moment";
import {
  dateFilterAir,
  formatDateNoTime,
  formatTime,
} from "../../helpers/formatDate";
import LoadingAir from "../LoadingAir/LoadingAir";
import _ from "lodash";
import Waiting from "../Common/Waiting";

const plainChairOptions = [
  {
    label: "Phổ thông",
    value: 1,
  },
  {
    label: "Phổ thông đặc biệt",
    value: 2,
  },
  {
    label: "Thương gia",
    value: 3,
  },
];

const timeOptions = [
  {
    label: "Trước 06:00",
    value: 1,
  },
  {
    label: "06:00 - 12:00",
    value: 2,
  },
  {
    label: "12:00 - 18:00",
    value: 3,
  },
  {
    label: "Sau 18:00",
    value: 4,
  },
];

const defaultChairCheckedList = [1, 2, 3];

const Step2 = ({
  onChangeStep,
  listFilght,
  setChooseFlight,
  chooseFlight,
  tripType,
  airport,
  airports,
  setStep,
  filterDay,
  setFilterDay,
  filterDayReturn,
  setFilterDayReturn,
  loadingSearchFlight,
  onBackButton,
  ChoosingStep,
  setChoosingStep,
}) => {
  const [openFilterAirline, setOpenFilterAirline] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const [checkedList, setCheckedList] = useState([]);
  const [filterTime, setFilterTime] = useState("");
  const [checkedListChair, setCheckedListChair] = useState(
    defaultChairCheckedList
  );
  const [plainOptions, setPlainOptions] = useState([]);
  const [typeSort, setTypeSort] = useState("price");
  const [sortIncrease, setSortIncrease] = useState(true);
  const [sortedFlights, setSortedFlights] = useState([]);
  const [filteredFlights, setFilteredFlights] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [detailTicket, setDetailTicket] = useState({});
  const [visibleFlightClass, setVisibleFlightClass] = useState({});
  const [groupedFlights, setGroupedFlights] = useState([]);
  const [filterDayOriginal] = useState(filterDay);
  const [activeDay, setActiveDay] = useState(filterDay);
  const [startDayCalender, setStartDayCalender] = useState(filterDay);
  const [rangeOriginal, setRangeOriginal] = useState(0);
  const [rangCalender, setRangCalender] = useState(0);
  useEffect(() => {
    if (filterDayReturn) {
      const daysDifference = moment(filterDayReturn).diff(
        moment(filterDay),
        "days"
      );
      setRangCalender(Math.max(daysDifference, 5));
      setRangeOriginal(Math.max(daysDifference, 5));
    } else {
      setRangCalender(5);
    }
  }, []);

  const toggleFlightClasses = (index) => {
    setVisibleFlightClass((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const onChange = (list) => {
    setCheckedList((prev) => {
      if (prev.includes(list)) {
        return prev.filter((item) => item !== list);
      }
      return [...prev, list];
    });
  };

  const handleFilterTime = (filteredData) => {
    const getTimeRange = (startHour, endHour) => ({
      start: moment().hour(startHour).minute(0).second(0),
      end: endHour ? moment().hour(endHour).minute(0).second(0) : undefined,
    });

    if (filterTime) {
      const data = filteredData.filter((item) => {
        const timeStartAir = moment(item.options?.[0]?.flights?.[0]?.startDate).set({
          year: moment().year(),
          month: moment().month(),
          date: moment().date(),
        });
        const timeRanges = {
          1: getTimeRange(0, 6),
          2: getTimeRange(6, 12),
          3: getTimeRange(12, 18),
          4: getTimeRange(18),
        };

        const { start, end } = timeRanges[filterTime] || {};
        return end
          ? start <= timeStartAir && end >= timeStartAir
          : start <= timeStartAir;
      });

      return data;
    }
    return filteredData;
  };

  const handleFilter = () => {
    // Bước 1: Lọc dữ liệu theo hãng máy bay
    setOpenFilter(false);
    setOpenFilterAirline(false);
    const filteredData = sortedFlights.filter((item) =>
      checkedList.includes(item.airline.code)
    );

    const filteredTime = handleFilterTime(filteredData);

    // Bước 2: Sắp xếp dữ liệu theo giá
    const sortedData = filteredTime.sort((a, b) => {
      if (typeSort === "price") {
        return sortIncrease
          ? a.totalPriceDisplay - b.totalPriceDisplay
          : b.totalPriceDisplay - a.totalPriceDisplay;
      }
      if (typeSort === "timeStart") {
        const startDateA = new Date(a?.options?.[0]?.flights?.[0]?.startDate);
        const startDateB = new Date(b?.options?.[0]?.flights?.[0]?.startDate);
        return sortIncrease ? startDateA - startDateB : startDateB - startDateA;
      }

      return sortIncrease
        ? a.totalPriceDisplay - b.totalPriceDisplay
        : b.totalPriceDisplay - a.totalPriceDisplay;
    });
    return setFilteredFlights(sortedData);
  };

  useEffect(() => {
    handleFilter();
  }, [sortIncrease, sortedFlights, typeSort]);

  useEffect(() => {
    if (tripType === "oneWay") {
      if (ChoosingStep === 1) {
        setSortedFlights(listFilght);
      } else {
        setSortedFlights([]);
      }
    } else {
      if (ChoosingStep === 1) {
        setSortedFlights(
          listFilght.filter(
            (item) => item.options?.[0]?.flights?.[0]?.startPoint === airport[0]
          )
        );
      } else if (ChoosingStep === 2) {
        setSortedFlights(
          listFilght.filter(
            (item) => item.options?.[0]?.flights?.[0]?.startPoint === airport[1]
          )
        );
      } else {
        setSortedFlights([]);
      }
    }

    const airlines = listFilght.reduce((acc, flight) => {
      if (!_.some(acc, (item) => item.label === flight.airline.name)) {
        acc.push({
          label: flight.airline.name,
          image: `${process.env.REACT_APP_BASE_URL}/${flight.airline.iconUrl}`,
          value: flight.airline.code,
        });
      }
      return acc;
    }, []);
    setPlainOptions(airlines);
    setCheckedList(_.map(airlines, (air) => air.value));
  }, [ChoosingStep, listFilght, airport, tripType]);

  function groupFlightsByClass(fareDataList) {
    const grouped = fareDataList.reduce((acc, currentFareData) => {
      const flightInfo = currentFareData?.options?.[0]?.flights?.[0];

      // Tạo key để xác định duy nhất một chuyến bay dựa vào StartDate và Airline
      const key = `${flightInfo.startDate}-${currentFareData.airline?.code}`;

      if (!acc[key]) {
        // Nếu chuyến bay chưa tồn tại trong kết quả nhóm, thêm nó với các hạng ghế hiện tại
        acc[key] = {
          startDate: flightInfo.startDate,
          airline: currentFareData.airline,
          flights: [], // Chứa thông tin các hạng ghế cho cùng một chuyến bay
        };
      }

      // Thêm hạng ghế vào chuyến bay đã được nhóm
      acc[key].flights.push(currentFareData);

      return acc;
    }, {});

    // Trả về kết quả dưới dạng mảng
    return Object.values(grouped);
  }

  // Gọi hàm và in kết quả
  useEffect(() => {
    setGroupedFlights(groupFlightsByClass(filteredFlights));
  }, [filteredFlights]);

  const selectFilterDay = (currentDate) => {
    if (ChoosingStep === 3) return;
    if (ChoosingStep === 1) {
      setFilterDay(dateFilterAir(currentDate));
    } else {
      setFilterDayReturn(dateFilterAir(currentDate));
    }
  };

  const renderDay = (index) => {
    const indexFocus = index;
    const dateNames = [
      "Chủ nhật",
      "Thứ 2",
      "Thứ 3",
      "Thứ 4",
      "Thứ 5",
      "Thứ 6",
      "Thứ 7",
    ];
    const currentDate = moment(startDayCalender, "YYYY-MM-DD").add(
      Math.abs(indexFocus),
      "days"
    );
    const day = currentDate.day();
    const color = day === 0 ? "#D72F20" : day === 6 ? "#F6C95A" : "#0b2727";

    return (
      <div
        key={index}
        className={`flex flex-col rounded p-2 gap-2 justify-center items-center text-[${color}] ${
          activeDay === dateFilterAir(currentDate) ? "calender-active" : ""
        }`}
        onClick={() => {
          setActiveDay(dateFilterAir(currentDate));
          selectFilterDay(currentDate);
        }}
      >
        <div className="text-[14px] whitespace-nowrap">
          {moment(currentDate).isSame(moment(), "day")
            ? "Hôm nay"
            : dateNames[day]}
        </div>
        <div className="text-[14px] font-bold">
          {currentDate.format("DD/MM")}
        </div>
      </div>
    );
  };

  const calender = useMemo(() => {
    return Array(rangCalender + 1)
      .fill("")
      .map((_, index) => renderDay(index));
  }, [rangCalender, activeDay, startDayCalender]);

  const handleSort = (type) => {
    setTypeSort(type);
    setSortIncrease((prev) => (type === typeSort ? !prev : true));
  };

  const handleSelectTicket = (item) => {
    if (tripType === "oneWay") {
      if (ChoosingStep === 1) {
        setChooseFlight([item]);
        setChoosingStep(3);
      } else {
        onChangeStep(3);
      }
    } else {
      if (ChoosingStep === 1) {
        setChooseFlight([item]);
        setChoosingStep(2);
      } else if (ChoosingStep === 2) {
        setChooseFlight([...chooseFlight, item]);
        setChoosingStep(3);
      } else {
        onChangeStep(3);
      }
      setActiveDay(filterDayReturn);
      setStartDayCalender(filterDayReturn);
      setRangCalender(30);
    }
    setDrawerVisible(false);
  };

  const ChooseFlightItem = (fare) => {
    return (
      <div
        key={fare.fareDataId}
        className="w-full px-2 py-2 bg-white rounded-[20px] mb-4 "
      >
        <Row
          gutter={8}
          className="flex-nowrap items-center"
          justify={"space-between"}
        >
          <Col span={5}>
            <div className="flex flex-col gap-2 items-center">
              <img
                className="w-[28px] h-[28px]"
                src={`${process.env.REACT_APP_BASE_URL}/${fare.airline.iconUrl}`}
                alt=""
              />
              {fare.options?.[0]?.flights?.[0]?.segments?.map((segment) => (
                <p className="text-[12px] text-primary text-center mb-0">
                  {fare.airline.code} {segment?.flightNumber || ""}/{" "}
                  {segment?.fareClassName}
                </p>
              ))}
            </div>
          </Col>
          <Col span={14}>
            <Row align={"middle"} justify={"space-between"}>
              <Col>
                <div className="flex flex-col gap-1">
                  <h4 className="font-bold text-[12px] text-center">
                    {formatTime(fare?.options?.[0]?.flights?.[0]?.startDate)}
                  </h4>
                  <p className="text-[10px] text-center">
                    {fare?.options?.[0]?.flights?.[0]?.startPoint}
                  </p>
                  <h4 className="font-bold text-[8px] text-center">
                    {formatDateNoTime(
                      fare?.options?.[0]?.flights?.[0]?.startDate
                    )}
                  </h4>
                </div>
              </Col>
              <Col className="justify-center text-center">
                <p className="text-[10px] text-[#808089]">
                  {calculateTimeDifference(
                    fare?.options?.[0]?.flights?.[0]?.startDate,
                    fare?.options?.[0]?.flights?.[0]?.endDate
                  )}
                </p>
                <img className="w-14" src="/images/flight-line.svg" alt="" />

                <p className="text-[10px] text-[#808089]">
                  {fare?.options?.[0]?.flights?.[0]?.stopNum === 0
                    ? "Bay thẳng"
                    : `${fare?.options?.[0]?.flights?.[0]?.stopNum} điểm dừng`}
                </p>
              </Col>
              <Col>
                <div className="flex flex-col gap-1">
                  <h4 className="font-bold text-[12px] text-center">
                    {formatTime(fare?.options?.[0]?.flights?.[0]?.endDate)}
                  </h4>
                  <p className="text-[10px] text-center">
                    {fare?.options?.[0]?.flights?.[0]?.endPoint}
                  </p>
                  <h4 className="font-bold text-[8px] text-center">
                    {formatDateNoTime(
                      fare?.options?.[0]?.flights?.[0]?.endDate
                    )}
                  </h4>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={5}>
            <div className="font-bold text-primary text-[14px] text-center">
              {formatNumberWithDots(fare.totalPriceDisplay)} {fare.currency}
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="bg-primary min-h-screen relative flex flex-col step2 overflow-hidden">
      <section className="step-indicator !block !p-0">
        <div className="flex items-end pr-[14px] pt-[9px]">
          <Button
            className="h-[60px] !w-[50px]"
            ghost
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                className="text-primary"
                fill="currentColor"
              >
                <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
              </svg>
            }
            onClick={() => {
              setChooseFlight([]);
              setFilterDay("");
              setStep((prev) => prev - 1);
              setChoosingStep(1);
            }}
          ></Button>
          <div className="flex gap-[12.5px] w-11/12 overflow-auto calender-air">
            {calender}
          </div>
        </div>
        <div className="justify-between items-center h-14 flex px-2">
          <Button
            className="rounded-[20px] text-sm px-6"
            icon={
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
              >
                <g clipPath="url(#clip0_281_3487)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.66663 2.50002C1.66663 2.03978 2.03972 1.66669 2.49996 1.66669H17.5C17.9602 1.66669 18.3333 2.03978 18.3333 2.50002V4.65484C18.3333 5.09687 18.1577 5.52079 17.8451 5.83335L12.5 11.1785V15.8334C12.5 16.149 12.3216 16.4376 12.0393 16.5787L8.70597 18.2454C8.44765 18.3745 8.14086 18.3607 7.89518 18.2089C7.6495 18.0571 7.49996 17.7888 7.49996 17.5V11.1785L2.15478 5.83335C1.84222 5.52079 1.66663 5.09687 1.66663 4.65484V2.50002ZM3.33329 3.33335V4.65484L8.92255 10.2441C9.07883 10.4004 9.16663 10.6123 9.16663 10.8334V16.1517L10.8333 15.3183V10.8334C10.8333 10.6123 10.9211 10.4004 11.0774 10.2441L16.6666 4.65484V3.33335H3.33329Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_281_3487">
                    <rect
                      width="16.6667"
                      height="16.6667"
                      fill="white"
                      transform="translate(1.66663 1.66669)"
                    />
                  </clipPath>
                </defs>
              </svg>
            }
            onClick={() => setOpenFilter(true)}
          >
            Lọc
          </Button>
          <Popover
            overlayStyle={{ maxWidth: "unset" }}
            content={
              <div className="inline-block px-3">
                <div className="flex flex-col gap-2">
                  {plainOptions.map((item) => (
                    <Checkbox
                      key={item.value}
                      onChange={() => onChange(item.value)}
                      checked={checkedList.includes(item.value)}
                      className="mb-2"
                    >
                      <div className="flex gap-4 items-center">
                        <div>
                          <img className="h-5" src={item.image} alt="" />
                        </div>
                        <p>{item.label}</p>
                      </div>
                    </Checkbox>
                  ))}
                </div>
                <Button
                  className="bg-primary text-white rounded-[20px] w-[100%] mt-2"
                  size="small"
                  variant="solid"
                  onClick={handleFilter}
                  type="primary"
                >
                  Áp dụng
                </Button>
              </div>
            }
            title="Lọc theo hãng"
            trigger="click"
            open={openFilterAirline}
            onOpenChange={(visible) => setOpenFilterAirline(visible)}
          >
            <Button
              className="rounded-[20px] text-sm px-3"
              icon={
                <svg
                  className="w-[12px] text-primary"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 24L10 24L16.25 13.8L23.125 13.8C24.1625 13.8 25 12.996 25 12C25 11.004 24.1625 10.2 23.125 10.2L16.25 10.2L10 -6.19336e-07L7.5 -7.22559e-07L10.625 10.2L3.75 10.2L1.875 7.2L1.57416e-06 7.2L1.25 12L1.12992e-06 16.8L1.875 16.8L3.75 13.8L10.625 13.8L7.5 24Z"
                    fill="currentColor"
                  />
                </svg>
              }
              onClick={() => setOpenFilterAirline(!openFilterAirline)}
            >
              Hãng
            </Button>
          </Popover>
          <Button
            className="rounded-[20px] text-sm px-3"
            onClick={() => handleSort("timeStart")}
          >
            Giờ đi
            {typeSort === "timeStart" && (
              <div className={`${sortIncrease ? "" : "rotate-180 pt-1"}`}>
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  className="h-[14px] text-primary"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.08901 4.72903C0.836998 4.47697 0.83699 4.06828 1.08902 3.81625L3.81621 1.08906C4.06827 0.837005 4.47696 0.836993 4.72899 1.08906L1.08901 4.72903ZM1.08901 4.72903C1.34105 4.9811 1.74974 4.98109 2.0018 4.72903L3.62718 3.10365L3.62718 12.4542C3.62718 12.8107 3.91616 13.0996 4.27262 13.0996C4.62907 13.0996 4.91806 12.8107 4.91806 12.4542L4.91806 3.10365L6.54343 4.72899C6.79546 4.98107 7.20416 4.98106 7.45622 4.729C7.58219 4.60302 7.64525 4.43766 7.64525 4.27262C7.64525 4.10759 7.58219 3.94223 7.45618 3.81625C7.45618 3.81625 7.45617 3.81625 7.45617 3.81624L4.729 1.08907L1.08901 4.72903Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.2"
                  />
                </svg>
              </div>
            )}
          </Button>
          <Button
            className="rounded-[20px] text-sm px-6 w-[80px]"
            onClick={() => handleSort("price")}
          >
            Giá
            {typeSort === "price" && (
              <div className={`${sortIncrease ? "" : "rotate-180 pt-1"}`}>
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  className="h-[14px] text-primary"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.08901 4.72903C0.836998 4.47697 0.83699 4.06828 1.08902 3.81625L3.81621 1.08906C4.06827 0.837005 4.47696 0.836993 4.72899 1.08906L1.08901 4.72903ZM1.08901 4.72903C1.34105 4.9811 1.74974 4.98109 2.0018 4.72903L3.62718 3.10365L3.62718 12.4542C3.62718 12.8107 3.91616 13.0996 4.27262 13.0996C4.62907 13.0996 4.91806 12.8107 4.91806 12.4542L4.91806 3.10365L6.54343 4.72899C6.79546 4.98107 7.20416 4.98106 7.45622 4.729C7.58219 4.60302 7.64525 4.43766 7.64525 4.27262C7.64525 4.10759 7.58219 3.94223 7.45618 3.81625C7.45618 3.81625 7.45617 3.81625 7.45617 3.81624L4.729 1.08907L1.08901 4.72903Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.2"
                  />
                </svg>
              </div>
            )}
          </Button>
        </div>
      </section>
      {loadingSearchFlight ? (
        <Waiting
          airport={airport}
          time={
            tripType === "oneWay" ? [filterDay] : [filterDay, filterDayReturn]
          }
        />
      ) : (
        <>
          {sortedFlights.length === 0 && ChoosingStep === 1 && (
            <>
              <div className="flex w-full absolute top-[135px] left-1/2 transform -translate-x-1/2 justify-center items-center gap-8">
                <div className="flex flex-col gap-1">
                  <div className="text-white font-semibold text-[18px]">
                    {airport?.[0]}
                  </div>
                </div>
                <div className="relative">
                  <svg
                    width="123"
                    height="47"
                    viewBox="0 0 123 47"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-primary"
                  >
                    <path
                      d="M0 20L5 22.8868V17.1132L0 20ZM123 20L118 17.1132V22.8868L123 20ZM4.5 20.5H118.5V19.5H4.5V20.5Z"
                      fill="white"
                    />
                    <g filter="url(#filter0_d_212_3608)">
                      <circle cx="62.5" cy="19.5" r="19.5" fill="white" />
                    </g>
                    <path
                      d="M71.7335 30.404L73.3261 28.1785L68.063 16.3724L72.4426 10.2524C73.1035 9.32878 72.8628 8.06044 71.9037 7.4128C70.9446 6.76516 69.6368 6.9879 68.9759 7.91147L64.5963 14.0316L51.3703 13.3529L49.7777 15.5784L61.013 19.0389L56.6333 25.159L53.1278 25.2675L51.9333 26.9366L56.7741 28.5549L60.0223 32.3987L61.2167 30.7296L60.1 27.4999L64.4797 21.3798L71.7335 30.404Z"
                      fill="currentColor"
                    />
                    <defs>
                      <filter
                        id="filter0_d_212_3608"
                        x="39"
                        y="0"
                        width="47"
                        height="47"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dy="4" />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_212_3608"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_212_3608"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div className="flex flex-col gap-1">
                  <div className="text-white font-semibold text-[18px]">
                    {" "}
                    {airport?.[1]}
                  </div>
                </div>
              </div>
              <h2 className="w-full text-white font-semibold text-[18px] text-center absolute top-[380px] left-1/2 transform -translate-x-1/2 p-4">
                Không tìm thấy chuyển bay phù hợp, vui lòng tìm kiếm lại
              </h2>
            </>
          )}
          <div
            className={`flex-1 flex flex-col items-center px-4 py-2
             max-h-[calc(100vh-125px)] ${ChoosingStep === 3 ? "max-h-[calc(100vh-242px)] overflow-auto" : "max-h-[calc(100vh-120px)]"}`}
          >
            {ChoosingStep === 1 && sortedFlights.length && (
              <div className="w-full mb-2">
                <div className="h-8 text-white font-bold text-[12px] flex items-center">
                  Vé chiều đi
                </div>
              </div>
            )}
            {ChoosingStep === 2 && (
              <div className="w-full flex flex-col gap-2 mb-2">
                <div className="flex justify-between items-center">
                  <b className="text-white font-bold text-[12px]">
                    Vé chiều đi
                  </b>
                  <Button
                    onClick={() => {
                      setChoosingStep(1);
                      setChooseFlight([]);
                      setActiveDay(filterDay);
                      setStartDayCalender(filterDayOriginal);
                      setRangCalender(rangeOriginal);
                    }}
                    className="rounded-[20px] text-center  bg-white text-primary border-primary text-[10px]"
                  >
                    Thay đổi
                  </Button>
                </div>
                {chooseFlight.map((item, index) => (
                  <ChooseFlightItem {...item} key={index} />
                ))}

                <b className="text-white font-bold text-[12px] text-center">
                  {" "}
                  Vé chiều về
                  <DoubleRightOutlined className="rotate-90 ml-2" />
                </b>
              </div>
            )}
            {ChoosingStep === 3 && (
              <div className="w-full flex flex-col gap-2 mb-2">
                <div className="flex justify-between items-center">
                  <b className="text-white font-bold text-[12px]">
                    Vé chiều đi
                  </b>
                  <Button
                    onClick={() => {
                      setChoosingStep(1);
                      setChooseFlight([]);
                      setActiveDay(filterDay);
                      setStartDayCalender(filterDayOriginal);
                    }}
                    className="rounded-[20px] text-center  bg-white text-primary border-primary text-[10px]"
                  >
                    Thay đổi
                  </Button>
                </div>
                {chooseFlight.slice(0, 1).map((item, index) => (
                  <ChooseFlightItem {...item} key={index} />
                ))}
                {tripType !== "oneWay" && (
                  <>
                    <div className="flex justify-between items-center">
                      <b className="text-white font-bold text-[12px]">
                        Vé chiều về
                      </b>
                      <Button
                        onClick={() => {
                          setChoosingStep(2);
                          setChooseFlight((prev) => [prev[0]]);
                        }}
                        className="rounded-[20px] text-center  bg-white text-primary border-primary text-[10px]"
                      >
                        Thay đổi
                      </Button>
                    </div>
                    {chooseFlight.slice(1, 2).map((item, index) => (
                      <ChooseFlightItem {...item} key={index} />
                    ))}
                  </>
                )}
              </div>
            )}
            {loadingSearchFlight ? (
              <div>
                <LoadingAir />
                <div className="text-white flex flex-col mt-10 w-3/4 mx-auto items-center">
                  <div>Vui lòng đợi trong giây lát</div>
                  <div>hệ thống đang tìm kiếm chuyến bay ...</div>
                </div>
              </div>
            ) : (
              <div className="max-h-full overflow-auto list-air-flight w-full">
                {groupedFlights.map((airline, index) =>
                  airline.flights.map((item, flightIndex) => {
                    if (flightIndex === 0)
                      return (
                        <div
                          key={flightIndex}
                          onClick={() => {
                            setDetailTicket(item);
                            setDrawerVisible(true);
                          }}
                          className="w-full px-2 py-2 bg-white rounded-[20px] mb-4"
                        >
                          <Row
                            className="items-center"
                            justify={"space-between"}
                          >
                            <Col span={13}>
                              <Row gutter={0} align={"middle"}>
                                <Col className="flex flex-col gap-1">
                                  <h4 className="font-bold text-[12px] text-center">
                                    {formatTime(
                                      item?.options?.[0]?.flights?.[0]
                                        ?.startDate
                                    )}
                                  </h4>
                                  <p className="text-[10px] text-center">
                                    {
                                      item?.options?.[0]?.flights?.[0]
                                        ?.startPoint
                                    }
                                  </p>
                                  <h4 className="font-bold text-[8px] text-center">
                                    {formatDateNoTime(
                                      item?.options?.[0]?.flights?.[0]?.endDate
                                    )}
                                  </h4>
                                </Col>
                                <Col className="justify-center text-center">
                                  <p className="text-[10px] text-[#808089]">
                                    {calculateTimeDifference(
                                      item?.options?.[0]?.flights?.[0]
                                        ?.startDate,
                                      item?.options?.[0]?.flights?.[0]?.endDate
                                    )}
                                  </p>
                                  <img src="/images/flight-line.svg" alt="" />

                                  <p className="text-[10px] text-[#808089]">
                                    {item?.options?.[0]?.flights?.[0]
                                      ?.stopNum === 0
                                      ? "Bay thẳng"
                                      : `${item?.options?.[0]?.flights?.[0]?.stopNum} điểm dừng`}
                                  </p>
                                </Col>
                                <Col className="flex flex-col gap-1">
                                  <h4 className="font-bold text-[12px] text-center">
                                    {formatTime(
                                      item?.options?.[0]?.flights?.[0]?.endDate
                                    )}
                                  </h4>
                                  <p className="text-[10px] text-center">
                                    {item?.options?.[0]?.flights?.[0]?.endPoint}
                                  </p>
                                  <h4 className="font-bold text-[8px] text-center">
                                    {formatDateNoTime(
                                      item?.options?.[0]?.flights?.[0]?.endDate
                                    )}
                                  </h4>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={11}>
                              <div className="flex gap-1 items-center mb-2">
                                <div className="font-bold text-primary text-[14px] ">
                                  {formatNumberWithDots(item.totalPriceDisplay)}{" "}
                                  {item.currency}
                                </div>
                                <Button
                                  className="rounded-[16px] h-6 text-[10px] p-1 px-1 border-primary"
                                  variant="outlined"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectTicket(item);
                                  }}
                                >
                                  <p className="text-primary text-[12px]">
                                    Chọn vé
                                  </p>
                                </Button>
                              </div>

                              <div className="flex gap-1 items-center justify-between">
                                <p className="text-[10px] text-[#808089]">
                                  /
                                  {_.sum([
                                    item["adt"],
                                    item["chd"],
                                    item["inf"],
                                  ])}{" "}
                                  Hành khách
                                </p>
                                <p className="text-primary text-[12px] flex gap-1 items-center cursor-pointer">
                                  Chi tiết{" "}
                                  <svg
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-primary"
                                  >
                                    <path
                                      d="M1 1L4.176 4L7.352 1"
                                      stroke="currentColor"
                                    />
                                    <path
                                      d="M1 4L4.176 7L7.352 4"
                                      stroke="currentColor"
                                    />
                                  </svg>
                                </p>
                              </div>
                            </Col>
                          </Row>
                          <hr className="my-2" />
                          <Row className="justify-between items-center">
                            <div>
                              <div className="flex gap-2 items-center">
                                <img
                                  className="w-[28px] h-[28px]"
                                  src={`${process.env.REACT_APP_BASE_URL}/${item.airline.iconUrl}`}
                                  alt=""
                                />
                                <div className="flex flex-col gap-1">
                                  <p className="text-[10px]">
                                    {item.airline.name || ""}
                                  </p>
                                  {item.options?.[0]?.flights?.[0]?.segments?.map(
                                    (segment, index) => (
                                      <div key={segment.id}>
                                        <p className="text-[12px] text-primary">
                                          {item.airline.code}{" "}
                                          {segment?.flightNumber || ""}/{" "}
                                          {segment?.fareClassName}
                                        </p>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                            {airline.flights.length > 1 && (
                              <Button
                                type="primary"
                                ghost
                                className="rounded-[20px]  py-0 px-2 w-fit h-6 text-[10px]"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleFlightClasses(index);
                                }}
                              >
                                <p className="text-primary text-[12px] flex gap-1 items-center cursor-pointer">
                                  {airline.flights.length - 1} hạng vé khác{" "}
                                  <svg
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-primary"
                                  >
                                    <path
                                      d="M1 1L4.176 4L7.352 1"
                                      stroke="currentColor"
                                    />
                                    <path
                                      d="M1 4L4.176 7L7.352 4"
                                      stroke="currentColor"
                                    />
                                  </svg>
                                </p>
                              </Button>
                            )}
                          </Row>
                          {/* Hiển thị các hạng vé khác khi được yêu cầu */}
                          {visibleFlightClass[index] &&
                            airline.flights
                              .slice(1)
                              .map((extraClass, extraIndex) => (
                                <div
                                  key={`${index}-${extraIndex}`}
                                  className="w-full mt-2 px-2 py-2 bg-white border-[1px] border-primary border-solid rounded-[20px]"
                                  onClick={() => {
                                    setDetailTicket(extraClass);
                                    setDrawerVisible(true);
                                  }}
                                >
                                  <Row
                                    className="items-center"
                                    justify={"space-between"}
                                  >
                                    <Col span={13}>
                                      <Row gutter={0} align={"middle"}>
                                        <Col className="flex flex-col gap-1">
                                          <h4 className="font-bold text-[12px]">
                                            {formatTime(
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.startDate
                                            )}
                                          </h4>
                                          <p className="text-[10px]">
                                            {
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.startPoint
                                            }
                                          </p>
                                        </Col>
                                        <Col className="justify-center text-center">
                                          <p className="text-[10px] text-[#808089]">
                                            {calculateTimeDifference(
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.startDate,
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.endDate
                                            )}
                                          </p>
                                          <img
                                            src="/images/flight-line.svg"
                                            alt=""
                                          />

                                          <p className="text-[10px] text-[#808089]">
                                            {extraClass?.options?.[0]
                                              ?.flights?.[0]?.stopNum === 0
                                              ? "Bay thẳng"
                                              : `${extraClass?.options?.[0]?.flights?.[0]?.stopNum} điểm dừng`}
                                          </p>
                                        </Col>
                                        <Col className="flex flex-col gap-1">
                                          <h4 className="font-bold text-[12px]">
                                            {formatTime(
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.endDate
                                            )}
                                          </h4>
                                          <p className="text-[10px]">
                                            {
                                              extraClass?.options?.[0]
                                                ?.flights?.[0]?.endPoint
                                            }
                                          </p>
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col span={11}>
                                      <div className="flex gap-2 items-center mb-2">
                                        <div>
                                          <div className="text-primary text-[14px] font-semibold mt-1">
                                            {formatNumberWithDots(
                                              extraClass.totalPriceDisplay
                                            )}{" "}
                                            {extraClass.currency}
                                          </div>
                                        </div>
                                        <Button
                                          className="rounded-[16px] h-6 text-[10px] p-1 px-1 border-primary"
                                          variant="outlined"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSelectTicket(extraClass);
                                          }}
                                        >
                                          <p className="text-primary text-[12px]">
                                            Chọn vé
                                          </p>
                                        </Button>
                                      </div>

                                      <div className="flex gap-1 items-center justify-between">
                                        <p className="text-[10px] text-[#808089]">
                                          /
                                          {_.sum([
                                            extraClass["adt"],
                                            extraClass["chd"],
                                            extraClass["inf"],
                                          ])}{" "}
                                          Hành khách
                                        </p>
                                        <p className="text-primary text-[12px] flex gap-1 items-center cursor-pointer">
                                          Chi tiết{" "}
                                          <svg
                                            width="8"
                                            height="8"
                                            viewBox="0 0 8 8"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="text-primary"
                                          >
                                            <path
                                              d="M1 1L4.176 4L7.352 1"
                                              stroke="currentColor"
                                            />
                                            <path
                                              d="M1 4L4.176 7L7.352 4"
                                              stroke="currentColor"
                                            />
                                          </svg>
                                        </p>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <div>
                                      <div className="flex gap-2 items-center">
                                        <img
                                          className="w-[28px] h-[28px]"
                                          src={`${process.env.REACT_APP_BASE_URL}/${item.airline.iconUrl}`}
                                          alt=""
                                        />
                                        <div className="flex flex-col gap-1">
                                          <p className="text-[10px]">
                                            {item.airline.name || ""}
                                          </p>
                                          {item.options?.[0]?.flights?.[0]?.segments?.map(
                                            (segment, index) => (
                                              <div key={segment.id}>
                                                <p className="text-[12px] text-primary">
                                                  {item.airline.code}{" "}
                                                  {segment?.flightNumber || ""}/{" "}
                                                  {segment?.fareClassName}
                                                </p>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </Row>
                                </div>
                              ))}
                        </div>
                      );
                  })
                )}
              </div>
            )}
          </div>
          {ChoosingStep === 3 ? (
            <div className="sticky bottom-0 right-0 w-full">
              <div className="bg-white  shadow p-4">
                <Row justify={"space-between"}>
                  <Col className="font-bold text-[#808089] text-md">
                    Tổng tiền
                  </Col>
                  <Col className="font-bold text-primary text-md">
                    {formatNumberWithDots(
                      chooseFlight.reduce((a, b) => a + b.totalPriceDisplay, 0)
                    )}{" "}
                    {chooseFlight?.[0]?.currency}
                  </Col>
                </Row>
                <Button
                  className="w-full mt-4 h-10 font-bold"
                  onClick={() => onChangeStep(3)}
                  type="primary"
                >
                  <span className="font-bold"> Tiếp Tục</span>
                </Button>
              </div>
            </div>
          ) : sortedFlights.length === 0 && ChoosingStep === 1 ? (
            <div className="sticky bottom-10 right-0 w-full shadow text-center">
              <Button
                onClick={onBackButton}
                variant="outlined"
                className="w-[208px] h-[45px] rounded-[10px] text-center mx-auto text-[15px]"
              >
                <span className="font-semibold">Quay lại</span>
              </Button>
            </div>
          ) : (
            <></>
          )}
        </>
      )}

      <Drawer
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenFilter(false)}
        open={openFilter}
        footer={
          <div>
            <Button
              type="primary"
              onClick={handleFilter}
              className="w-full rounded-lg mt-4 h-12 text-[16px] font-semibold"
            >
              Áp dụng
            </Button>
          </div>
        }
        height="100vh"
      >
        <div className="header-filter">
          <div onClick={() => setOpenFilter(false)}>
            <CloseOutlined />
          </div>
          <div>Bộ lọc</div>
        </div>
        <div className="max-h-[calc(100%-41px)] overflow-y-auto overflow-x-h p-4">
          <div className="card-filter pb-4">
            <div className="card-filter-title">Lọc theo giờ khởi hành</div>
            <Row gutter={[16, 8]} className="flex mt-2 p-2 card-filter-body">
              {timeOptions.map((item) => (
                <Col span={12}>
                  <div
                    className={`border border-dashed border-[#d9d9d9] h-12 flex items-center justify-center ${filterTime === item.value ? "border-2 !border-solid !border-[#3875CA]" : ""}`}
                    onClick={() =>
                      setFilterTime((prev) =>
                        item.value === prev ? "" : item.value
                      )
                    }
                  >
                    {item.label}
                  </div>
                </Col>
              ))}
            </Row>
          </div>
          <div className="card-filter mt-6">
            <div className="card-filter-title">Lọc theo hãng</div>
            <div className="flex flex-col card-filter-body">
              {plainOptions.map((item) => (
                <Checkbox
                  key={item.value}
                  onChange={() => onChange(item.value)}
                  checked={checkedList.includes(item.value)}
                  className="mb-2"
                >
                  <div className="flex gap-2 items-center">
                    <div className="min-w-[100px]">
                      <img className="h-5" src={item.image} alt="" />
                    </div>
                    <p>{item.label}</p>
                  </div>
                </Checkbox>
              ))}
            </div>
          </div>
          <div className="card-filter mt-6">
            <div className="card-filter-title">Lọc theo hạng ghế</div>
            <div className="flex flex-col card-filter-body">
              {plainChairOptions.map((item) => (
                <Checkbox
                  key={item.value}
                  onChange={() => onChange(item.value)}
                  checked={checkedListChair.includes(item.value)}
                  className="mb-2"
                >
                  <div className="flex gap-2 items-center">
                    <p>{item.label}</p>
                  </div>
                </Checkbox>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
      <TicketDetailsDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        ticketDetails={detailTicket}
        airports={airports}
        tripType={tripType}
        ChoosingStep={ChoosingStep}
        setChooseFlight={setChooseFlight}
        setChoosingStep={setChoosingStep}
        onChangeStep={onChangeStep}
        chooseFlight={chooseFlight}
        handleSelectTicket={handleSelectTicket}
      />
    </div>
  );
};

export default Step2;
